{
  "title": "فريقي",
  "subtitle_zero": "لا يوجد مرؤوسون مباشرون",
  "subtitle_one": "مرؤوس مباشر واحد",
  "subtitle_two": "مرؤوسان مباشران",
  "subtitle_few": "{{count}} مرؤوسين مباشرين",
  "subtitle_many": "{{count}} مرؤوساً مباشراً",
  "subtitle_other": "{{count}} مرؤوس مباشر",
  "directReports": "المرؤوسون المباشرون",
  "directReportsHint": "الموظفون الذين أنت مديرهم أو مديرهم الثانوي.",
  "members": "أعضاء الفريق",
  "noDirectory": "لا يسمح دورك بفتح سجلات مرؤوسيك، لذا تبقى القائمة مخفية. اطلب من الموارد البشرية دورًا يتضمن صلاحية employee.view_team (يتضمنها دور المدير المباشر) لعرض مرؤوسيك هنا.",
  "empty": "لا يوجد مرؤوسون مباشرون",
  "emptyHint": "لا يرفع أحد تقاريره إلى سجلك الوظيفي بعد. تحدد الموارد البشرية المدير والمدير الثانوي في ملف كل موظف.",
  "notManager": "ليس لديك مرؤوسون مباشرون",
  "notManagerHint": "تُفتح هذه الصفحة للأعضاء الذين يكون سجلهم الوظيفي مديراً أو مديراً ثانوياً لموظفين آخرين.",
  "columns": { "name": "الاسم", "designation": "المسمى الوظيفي", "department": "القسم", "branch": "الفرع", "relation": "يرفع إليك بصفتك" },
  "relation": { "primary": "المدير", "secondary": "المدير الثانوي" },
  "tabs": { "today": "اليوم", "attendance": "الحضور", "leave": "الإجازات", "approvals": "الموافقات", "delegation": "التفويض" },
  "refresh": "تحديث",
  "updated": "آخر تحديث {{when}}",
  "today": {
    "status": {
      "present": "حاضر",
      "late": "متأخر",
      "absent": "غائب",
      "on_leave": "في إجازة",
      "missing_punch": "بصمة ناقصة",
      "weekly_off": "عطلة أسبوعية",
      "holiday": "عطلة رسمية",
      "not_in_yet": "لم يحضر بعد",
      "not_scheduled": "بلا جدول"
    },
    "live": { "IN": "داخل العمل الآن", "OUT": "سجّل الانصراف", "NONE": "لا بصمة بعد" },
    "firstIn": "الدخول",
    "lastOut": "الانصراف",
    "worked": "العمل",
    "workedLive": "العمل حتى الآن (مباشر)",
    "lateBy": "تأخر {{time}}",
    "halfDay": "{{type}} · نصف يوم",
    "pending_zero": "لا شيء بانتظارك",
    "pending_one": "عنصر واحد بانتظارك",
    "pending_two": "عنصران بانتظارك",
    "pending_few": "{{count}} عناصر بانتظارك",
    "pending_many": "{{count}} عنصراً بانتظارك",
    "pending_other": "{{count}} عنصر بانتظارك",
    "openDay": "فتح اليوم",
    "noRecord": "لم يُحتسب بعد",
    "totals": { "present": "حاضرون", "late": "متأخرون", "absent": "غائبون", "onLeave": "في إجازة", "missingPunch": "بصمة ناقصة", "inNow": "داخل العمل الآن", "presentHint": "يشمل المتأخرين", "ofReports": "من {{count}}" },
    "search": "ابحث في فريقك",
    "searchPlaceholder": "الاسم أو الرقم الوظيفي",
    "noMatch": "لا أحد في فريقك يطابق «{{search}}».",
    "empty": "لا مرؤوسين لعرضهم",
    "emptyHint": "يظهر مرؤوسوك هنا عندما تكون سجلاتهم الوظيفية نشطة.",
    "noAttendanceKey": "لا يسمح دورك بقراءة حضور مرؤوسيك. اطلب من الموارد البشرية دورًا يتضمن صلاحية attendance.view_team (يتضمنها دور المدير المباشر) لعرض لوحة اليوم."
  },
  "attendance": {
    "month": "الشهر",
    "day": "اليوم",
    "previous": "الشهر السابق",
    "next": "الشهر التالي",
    "employee": "الموظف",
    "allReports": "كل المرؤوسين",
    "date": "التاريخ",
    "empty": "لا سجلات حضور في هذه الفترة",
    "emptyHint": "تظهر السجلات بعد وصول البصمات واحتساب اليوم.",
    "readOnly": "للعرض فقط: طلب التصحيح يحتاج إلى صلاحية attendance.correct.",
    "notAReport": "هذا الموظف ليس من مرؤوسيك المباشرين: يُعرض فريقك كاملاً.",
    "columns": { "employee": "الموظف", "status": "الحالة", "in": "الدخول", "out": "الانصراف", "worked": "العمل", "late": "التأخير" },
    "prevPage": "الصفحة السابقة",
    "nextPage": "الصفحة التالية",
    "page": "الصفحة {{page}} من {{pages}} · {{total}} مرؤوسين"
  },
  "leave": {
    "upcoming": "الإجازات القادمة",
    "upcomingHint": "الإجازات المعتمدة والمعلّقة لمرؤوسيك التي تنتهي اليوم أو بعده (20 كحد أقصى).",
    "calendar": "تقويم إجازات الفريق",
    "includePending": "تضمين المعلّقة",
    "pendingForMe_zero": "لا طلبات إجازة بانتظارك",
    "pendingForMe_one": "طلب إجازة واحد بانتظارك",
    "pendingForMe_two": "طلبا إجازة بانتظارك",
    "pendingForMe_few": "{{count}} طلبات إجازة بانتظارك",
    "pendingForMe_many": "{{count}} طلب إجازة بانتظارك",
    "pendingForMe_other": "{{count}} طلب إجازة بانتظارك",
    "review": "مراجعة",
    "empty": "لا إجازات في هذا الشهر",
    "emptyHint": "تظهر هنا الإجازات المعتمدة والمعلّقة لمرؤوسيك.",
    "days": "الأيام",
    "previous": "الشهر السابق",
    "next": "الشهر التالي",
    "range": "{{from}} ← {{to}}"
  },
  "approvals": {
    "mine": "بانتظاري",
    "team": "كل فريقي",
    "teamHint": "للعرض فقط: أحدث {{count}} طلباً لمرؤوسيك المباشرين. القرارات تُتخذ على الصفوف التي بانتظارك.",
    "requests": "الطلبات",
    "requestsEmpty": "لا طلبات بانتظارك",
    "requestsEmptyHint": "تظهر هنا طلبات الإجازة والتصحيحات وغيرها المحالة إليك.",
    "teamEmpty": "لا طلبات من فريقك بعد",
    "more": "{{count}} طلبات أخرى بانتظارك في صندوق الموافقات",
    "openInbox": "فتح صندوق الموافقات",
    "reasons": "مبررات الحضور",
    "reasonsHint": "المبررات التي قدمها مرؤوسوك عن أيامهم. تبت فيما ينتظرك منها؛ والصفوف المعروضة بإشراف الموارد البشرية مميّزة.",
    "reasonsEmpty": "لا مبررات بانتظارك",
    "reasonsEmptyHint": "عندما يوضح أحد مرؤوسيك يوم تأخير أو غياب أو يوماً غير مكتمل، يظهر المبرر هنا.",
    "showAll": "عرض المبررات المبتوت فيها أيضاً",
    "viewOnly": "للعرض فقط",
    "waitingForAnswer": "بانتظار رد الموظف",
    "noTeamKey": "لا يسمح دورك بعرض طلبات فريقك (يلزم attendance.view_team أو leave.view_team)."
  },
  "delegation": {
    "title": "التفويض",
    "hint": "أثناء غيابك، يبت المفوَّض في الطلبات المحالة إليك. تظهر هنا التفويضات التي أنشأتها أو تلقيتها.",
    "manage": "فتح صفحة التفويضات"
  },
  "chip": {
    "label_zero": "لا شيء بانتظارك",
    "label_one": "عنصر واحد بانتظارك",
    "label_two": "عنصران بانتظارك",
    "label_few": "{{count}} عناصر بانتظارك",
    "label_many": "{{count}} عنصراً بانتظارك",
    "label_other": "{{count}} عنصر بانتظارك",
    "approvals_zero": "لا طلبات موافقة",
    "approvals_one": "طلب موافقة واحد",
    "approvals_two": "طلبا موافقة",
    "approvals_few": "{{count}} طلبات موافقة",
    "approvals_many": "{{count}} طلب موافقة",
    "approvals_other": "{{count}} طلب موافقة",
    "notes_zero": "لا مبررات حضور",
    "notes_one": "مبرر حضور واحد",
    "notes_two": "مبررا حضور",
    "notes_few": "{{count}} مبررات حضور",
    "notes_many": "{{count}} مبرر حضور",
    "notes_other": "{{count}} مبرر حضور"
  }
}
